import React, { useEffect, useState } from 'react';
import "../../assets/styles/Profile.css";
import { motion } from "framer-motion";
import Header from "../../components/Header.js";
import imgBtnUser from "../../imgs/bt-change-name.png";
import imgBtnPhone from "../../imgs/bt-change-phone.png";
import imgBtnMail from "../../imgs/bt-change-mail.png";
import imgBtnBank from "../../imgs/bt-change-bank.png";
import imgBtnBirthday from "../../imgs/bt-change-birtday.png";
import imgBtnUsd from "../../imgs/bt-change-usdt.png";
import imgBtnsp from "../../imgs/bt-sp.png";
import imgBtnPassword from "../../imgs/bt-change-pass.png";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Popup from "reactjs-popup";
import iconClose from "../../icons/icon-close.png";
import { apiGetRequestHistory } from "../../services/api.service.js";
import HtmlNote from "../../components/Profile/HtmlNote.js";

import * as yup from 'yup';


function Profile() {
  const location = useLocation();
  const { userName, data, webSetting } = location.state || {};
  const navigate = useNavigate();
  const [requestCode, setRequestCode] = useState("");
  const [requestHistory, setRequestHistory] = useState(null);
  const [requestHistoryError, setRequestHistoryError] = useState("");
  const [openRequestHistoryResult, setOpenRequestHistoryResult] = useState(false);
  const [showRequestHistoryHelp, setShowRequestHistoryHelp] = useState(false);
  const [isRequestHistoryCollapsed, setIsRequestHistoryCollapsed] = useState(false);
  const recentRequests = (data?.recent_requests || []).slice(0, 2);
  // danh sách mục thông tin tài khoản không được phép thay đổi (BE trả về khi check tài khoản)
  const disabledUpdateTypes = data?.disabled_update_types || [];
  // class nút: mục bị giới hạn thì làm mờ, không cho bấm
  const actionClass = (updateType) => {
    return disabledUpdateTypes.includes(updateType) ? "action-btn action-disabled" : "action-btn";
  };

  const requestStatusText = {
    no_process: "Đang chờ xử lý",
    approved: "Đã xử lý thành công",
    removed: "Đã từ chối",
  };
  const requestTypeText = {
    full_name: "Thay đổi họ và tên",
    phone_number: "Thay đổi số điện thoại",
    email: "Thay đổi email",
    bank: "Thay đổi tài khoản ngân hàng",
    birthday: "Thay đổi ngày sinh",
    usdt: "Thay đổi ví USDT",
    forget_password_withdraw: "Cấp lại mật khẩu rút tiền",
  };
  const getVerificationStatusText = (status, sendType) => {
    if (status === "success") return "Đã nhận xác thực hợp lệ";
    if (status === "invalid") return sendType === "email"
      ? "Đã nhận xác thực nhưng sai địa chỉ email"
      : "Đã nhận xác thực nhưng sai số điện thoại";
    return sendType === "email" ? "Chưa nhận được email xác thực" : "Chưa nhận được SMS xác thực";
  };
  const checkRequestHistory = async () => {
    const code = requestCode.trim();
    setRequestHistoryError("");
    if (!/^\d{8}$/.test(code)) {
      setRequestHistoryError("Vui lòng nhập đúng mã yêu cầu gồm 8 số.");
      return;
    }
    const result = await apiGetRequestHistory(userName, code);
    if (result?.code === 200 && result?.data?.request) {
      setRequestHistory(result.data.request);
      setOpenRequestHistoryResult(true);
    } else {
      setRequestHistoryError(result?.message || "Không tìm thấy yêu cầu.");
    }
  };

  const schema = yup.object().shape({
    name: yup.string().required('Name is required'),
    email: yup.string().email('Email is invalid').required('Email is required'),
    phoneNumber: yup.string().matches(/^[0-9]+$/, 'Phone number must be digits').required('Phone number is required'),
  });

  const shouldNavigate = (!userName || userName === "undefined");
  useEffect(() => {
    if (shouldNavigate) {
      navigate('/');
    }
  }, [navigate, shouldNavigate]);

  if (!shouldNavigate) {
    const changeInfo = async (typeModal) => {
      if (!userName) {
        return Swal.fire({ icon: "error", text: "Vui lòng nhập tên tài khoản." });
      } else {
        navigate("/change-info", { state: { userName, data, webSetting, typeModal } });
      }
    };

    return (
      <div className="container">
        <motion.div
          // className="app"
          // initial={{ opacity: 0 }}
          // animate={{ opacity: 1 }}
          // transition={{ duration: 5 }}
          // className="app"
          // initial={{ x: "-100vw", opacity: 0 }}
          // animate={{ x: 0, opacity: 1 }}
          // exit={{ x: "100vw", opacity: 0 }}
          // transition={{ type: "spring", stiffness: 100, damping: 20 }}
          className="app"
          initial={{ x: "100vw", opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          exit={{ x: "-100vw", opacity: 0 }}
          transition={{ type: "spring", stiffness: 1000, damping: 200, duration: 10 }}
        >
          <Header isPageSearch={false} />

          <div className="content">
            <div className="profile">
              <div className="request-history">
                <div className="request-history-heading">
                  <span className="profile-titlte">KIỂM TRA LỊCH SỬ YÊU CẦU</span>
                  <div className="request-history-help" onMouseEnter={() => setShowRequestHistoryHelp(true)} onMouseLeave={() => setShowRequestHistoryHelp(false)}>
                    <button type="button" className="request-history-help-icon" aria-label="Thông tin lịch sử yêu cầu" onClick={() => setShowRequestHistoryHelp((value) => !value)}>!</button>
                    {showRequestHistoryHelp && <div className="request-history-help-content">Danh sách chỉ hiển thị tối đa 2 yêu cầu gần nhất trong 48 giờ. Nhập mã yêu cầu 8 số để xem chi tiết kết quả xử lý.</div>}
                  </div>
                  <button type="button" className="request-history-collapse-button" onClick={() => setIsRequestHistoryCollapsed((value) => !value)}>{isRequestHistoryCollapsed ? "+" : "−"}</button>
                </div>
                {!isRequestHistoryCollapsed && recentRequests.length > 0 && <div className="recent-requests">
                  {recentRequests.map((request, index) => <div className={`recent-request-item status-${request.status}`} key={`${request.request_code}-${index}`}>
                    <div className="recent-request-main"><strong>{requestTypeText[request.update_type] || request.update_type}</strong><span>Mã yêu cầu: {request.request_code}</span></div>
                    <span className={`recent-request-status status-${request.status}`}>{requestStatusText[request.status] || request.status}</span>
                    {request.status === "no_process" && ["email", "phone_number"].includes(request.send_type) && <span className={`verification-status verification-${request.verification_status || "not_received"}`}>{getVerificationStatusText(request.verification_status || "not_received", request.send_type)}</span>}
                  </div>)}
                </div>}
                {!isRequestHistoryCollapsed && <div className="request-history-form">
                  <input type="text" inputMode="numeric" maxLength="8" value={requestCode} onChange={(event) => { setRequestCode(event.target.value.replace(/\D/g, "")); setRequestHistoryError(""); }} onKeyDown={(event) => event.key === "Enter" && checkRequestHistory()} placeholder="Nhập mã yêu cầu 8 số" />
                  <button type="button" onClick={checkRequestHistory}>Kiểm tra</button>
                </div>}
                {!isRequestHistoryCollapsed && requestHistoryError && <p className="request-history-error">{requestHistoryError}</p>}
              </div>
              {/* <span className="profile-titlte">THÔNG TIN CÁ NHÂN</span>
              <InfoUser /> */}
              <div className="action profile-action">
                <div className={actionClass("full_name")} onClick={disabledUpdateTypes.includes("full_name") ? undefined : () => changeInfo("full_name")}>
                  <img className="img-default" src={imgBtnUser} alt="icon-user" />
                </div>

                <div className={actionClass("usdt")} onClick={disabledUpdateTypes.includes("usdt") ? undefined : () => changeInfo("usdt")}>
                  <img className="img-default" src={imgBtnUsd} alt="icon-usdt" />
                </div>
              </div>
              <div className="action profile-action">
                <div className={actionClass("email")} onClick={disabledUpdateTypes.includes("email") ? undefined : () => changeInfo("email")}>
                  <img className="img-default" src={imgBtnMail} alt="icon-mail" />
                </div>
                <div className={actionClass("bank")} onClick={disabledUpdateTypes.includes("bank") ? undefined : () => changeInfo("bank")}>
                  <img className="img-default" src={imgBtnBank} alt="icon-bank" />
                </div>
              </div>
              <div className="action profile-action">
                <div className={actionClass("birthday")} onClick={disabledUpdateTypes.includes("birthday") ? undefined : () => changeInfo("birthday")}>
                  <img className="img-default" src={imgBtnBirthday} alt="icon-birthday" />
                </div>
                <div className={actionClass("phone_number")} onClick={disabledUpdateTypes.includes("phone_number") ? undefined : () => changeInfo("phone_number")}>
                  <img className="img-default" src={imgBtnPhone} alt="icon-phone" />
                </div>
              </div>
              <div className="action profile-action">
                <a className="action-btn" href="https://www.jun88be.net/forgetpassword">
                  <img className="img-default" src={imgBtnPassword} alt="icon-password" />
                </a>
                <a className="action-btn" href="https://jun88vp12.com/cskh/htDoiThongTin">
                  <img className="img-default" src={imgBtnsp} alt="icon-support" />
                </a>

              </div>

            </div>
          </div>
          <Popup open={openRequestHistoryResult} onClose={() => setOpenRequestHistoryResult(false)} position="center" closeOnDocumentClick overlayStyle={{ display: "flex", alignItems: "center", justifyContent: "center", background: "rgba(0, 0, 0, 0.35)" }} contentStyle={{ position: "relative", inset: "auto", width: "auto", padding: 0, border: "none", background: "transparent" }}>
            <div className="request-history-modal">
              <button type="button" className="request-history-modal-close" onClick={() => setOpenRequestHistoryResult(false)}><img src={iconClose} alt="Đóng" /></button>
              {requestHistory && <div className={`request-history-result status-${requestHistory.status}`}>
                <h3>KẾT QUẢ YÊU CẦU</h3>
                <p><strong>Loại yêu cầu:</strong> {requestTypeText[requestHistory.update_type] || requestHistory.update_type}</p>
                {requestHistory.data_update?.content && <p><strong>Nội dung yêu cầu:</strong> {requestHistory.data_update.content}</p>}
                <p><strong>Trạng thái:</strong> {requestStatusText[requestHistory.status] || requestHistory.status}</p>
                {requestHistory.status === "no_process" && ["email", "phone_number"].includes(requestHistory.send_type) && <p className={`verification-status verification-${requestHistory.verification_status || "not_received"}`}>{getVerificationStatusText(requestHistory.verification_status || "not_received", requestHistory.send_type)}</p>}
                {(requestHistory.note || requestHistory.result) && <div className="request-result-note"><strong>Ghi chú/Kết quả:</strong><HtmlNote html={requestHistory.note || requestHistory.result} /></div>}
                {requestHistory.createdAt && <p><strong>Ngày gửi:</strong> {new Date(requestHistory.createdAt).toLocaleString("vi-VN")}</p>}
              </div>}
            </div>
          </Popup>
        </motion.div>
      </div>
    );
  }
}

export default Profile;
